var map = {
	"./caret-arrow-down.svg": 593,
	"./caret-arrow-up.svg": 594,
	"./chevron-right-solid.svg": 595,
	"./icon-add-circular.png": 596,
	"./icon-add-circular.svg": 597,
	"./icon-add-group-2.png": 598,
	"./icon-add-group-2.svg": 599,
	"./icon-add-group.png": 600,
	"./icon-add-group.svg": 601,
	"./icon-add-question.png": 602,
	"./icon-add-question.svg": 603,
	"./icon-add-section.png": 604,
	"./icon-add-section.svg": 605,
	"./icon-alert-red.svg": 606,
	"./icon-arrow-down-white.png": 607,
	"./icon-arrow-down-white.svg": 608,
	"./icon-arrow-down.png": 609,
	"./icon-arrow-down.svg": 610,
	"./icon-arrow-up-white.png": 611,
	"./icon-arrow-up-white.svg": 612,
	"./icon-arrow-up.png": 613,
	"./icon-arrow-up.svg": 614,
	"./icon-badge-white.png": 615,
	"./icon-badge-white.svg": 616,
	"./icon-badge.png": 617,
	"./icon-badge.svg": 618,
	"./icon-banner-white.png": 619,
	"./icon-banner-white.svg": 620,
	"./icon-banner.png": 621,
	"./icon-banner.svg": 622,
	"./icon-bell.png": 623,
	"./icon-bell.svg": 624,
	"./icon-calendar-white.svg": 625,
	"./icon-calendar.png": 626,
	"./icon-calendar.svg": 627,
	"./icon-category-white.png": 628,
	"./icon-category-white.svg": 629,
	"./icon-category.png": 630,
	"./icon-category.svg": 631,
	"./icon-check-list-checked-white.png": 632,
	"./icon-check-list-checked-white.svg": 633,
	"./icon-check-list-checked.png": 634,
	"./icon-check-list-checked.svg": 635,
	"./icon-check.png": 636,
	"./icon-check.svg": 637,
	"./icon-checking.png": 638,
	"./icon-checking.svg": 639,
	"./icon-chevon-down.svg": 640,
	"./icon-chevon-left-white.png": 641,
	"./icon-chevon-left-white.svg": 642,
	"./icon-chevon-left.png": 643,
	"./icon-chevon-left.svg": 644,
	"./icon-chevon-right-white.png": 645,
	"./icon-chevon-right-white.svg": 646,
	"./icon-chevon-right.png": 647,
	"./icon-chevon-right.svg": 648,
	"./icon-chevron-down.png": 649,
	"./icon-chevron-down.svg": 650,
	"./icon-chevron-left-circle.png": 651,
	"./icon-chevron-left-circle.svg": 652,
	"./icon-chevron-right-circle.png": 653,
	"./icon-chevron-right-circle.svg": 654,
	"./icon-code-of-practice-accepted.png": 655,
	"./icon-code-of-practice-accepted.svg": 656,
	"./icon-code-of-practice-no-information.png": 657,
	"./icon-code-of-practice-no-information.svg": 658,
	"./icon-company-white.png": 659,
	"./icon-company-white.svg": 660,
	"./icon-company.svg": 661,
	"./icon-compare.svg": 662,
	"./icon-compliance-white.png": 663,
	"./icon-compliance-white.svg": 664,
	"./icon-compliance.png": 665,
	"./icon-compliance.svg": 666,
	"./icon-comprehensive- assessment.png": 667,
	"./icon-comprehensive- assessment.svg": 668,
	"./icon-contact-sign.png": 669,
	"./icon-contact-sign.svg": 670,
	"./icon-delete-circle-red.png": 671,
	"./icon-delete-circle-red.svg": 672,
	"./icon-detail.png": 673,
	"./icon-detail.svg": 674,
	"./icon-display-star.png": 675,
	"./icon-display-star.svg": 676,
	"./icon-double-chevon-left-white.png": 677,
	"./icon-double-chevon-left-white.svg": 678,
	"./icon-double-chevon-left.png": 679,
	"./icon-double-chevon-left.svg": 680,
	"./icon-double-chevon-right-white.png": 681,
	"./icon-double-chevon-right-white.svg": 682,
	"./icon-double-chevon-right.png": 683,
	"./icon-double-chevon-right.svg": 684,
	"./icon-download-file.png": 685,
	"./icon-download-file.svg": 686,
	"./icon-download.gif": 687,
	"./icon-download.png": 688,
	"./icon-download.svg": 689,
	"./icon-edit.png": 690,
	"./icon-edit.svg": 691,
	"./icon-esg.png": 692,
	"./icon-esg.svg": 693,
	"./icon-excel.svg": 694,
	"./icon-export-white.svg": 695,
	"./icon-export.png": 696,
	"./icon-export.svg": 697,
	"./icon-gallery-white.png": 698,
	"./icon-gallery-white.svg": 699,
	"./icon-hammer-blue.svg": 700,
	"./icon-hammer-green.svg": 701,
	"./icon-hammer-white.svg": 702,
	"./icon-help-error.svg": 703,
	"./icon-help.png": 704,
	"./icon-help.svg": 705,
	"./icon-history.png": 706,
	"./icon-history.svg": 707,
	"./icon-home-white.png": 708,
	"./icon-home-white.svg": 709,
	"./icon-home.png": 710,
	"./icon-home.svg": 711,
	"./icon-image-crop-zoom-in.png": 712,
	"./icon-image-crop-zoom-in.svg": 713,
	"./icon-image-crop-zoom-out.png": 714,
	"./icon-image-crop-zoom-out.svg": 715,
	"./icon-lamp-blue.svg": 716,
	"./icon-lamp-white.svg": 717,
	"./icon-libra-white.png": 718,
	"./icon-libra-white.svg": 719,
	"./icon-libra.png": 720,
	"./icon-libra.svg": 721,
	"./icon-logout.png": 722,
	"./icon-logout.svg": 723,
	"./icon-padlock.svg": 724,
	"./icon-paper-download-white.svg": 725,
	"./icon-paste.svg": 726,
	"./icon-pentagon-white.png": 727,
	"./icon-pentagon-white.svg": 728,
	"./icon-pentagon.png": 729,
	"./icon-pentagon.svg": 730,
	"./icon-play-blue.svg": 731,
	"./icon-remove.png": 732,
	"./icon-remove.svg": 733,
	"./icon-risk-management-white.png": 734,
	"./icon-risk-management-white.svg": 735,
	"./icon-risk-management.png": 736,
	"./icon-risk-management.svg": 737,
	"./icon-risk-score-white.png": 738,
	"./icon-risk-score-white.svg": 739,
	"./icon-risk-score.png": 740,
	"./icon-risk-score.svg": 741,
	"./icon-schematic.svg": 742,
	"./icon-score-1-scale-4.png": 743,
	"./icon-score-1-scale-4.svg": 744,
	"./icon-score-1-scale-5.png": 745,
	"./icon-score-1-scale-5.svg": 746,
	"./icon-score-2-scale-4.png": 747,
	"./icon-score-2-scale-4.svg": 748,
	"./icon-score-2-scale-5.png": 749,
	"./icon-score-2-scale-5.svg": 750,
	"./icon-score-3-scale-4.png": 751,
	"./icon-score-3-scale-4.svg": 752,
	"./icon-score-3-scale-5.png": 753,
	"./icon-score-3-scale-5.svg": 754,
	"./icon-score-4-scale-4.png": 755,
	"./icon-score-4-scale-4.svg": 756,
	"./icon-score-4-scale-5.png": 757,
	"./icon-score-4-scale-5.svg": 758,
	"./icon-score-5-scale-5.png": 759,
	"./icon-score-5-scale-5.svg": 760,
	"./icon-score-scale-gray.png": 761,
	"./icon-score-scale-gray.svg": 762,
	"./icon-score-scale.png": 763,
	"./icon-score-scale.svg": 764,
	"./icon-search.png": 765,
	"./icon-search.svg": 766,
	"./icon-sourcing-white.svg": 767,
	"./icon-sourcing.svg": 768,
	"./icon-speaker-white.png": 769,
	"./icon-speaker-white.svg": 770,
	"./icon-speaker.png": 771,
	"./icon-speaker.svg": 772,
	"./icon-ssr.png": 773,
	"./icon-supplier-discovery-white.png": 774,
	"./icon-supplier-discovery-white.svg": 775,
	"./icon-supplier-discovery.png": 776,
	"./icon-supplier-discovery.svg": 777,
	"./icon-trapezoid-delete.svg": 778,
	"./icon-trapezoid-plus.svg": 779,
	"./icon-trash-red.png": 780,
	"./icon-trash-red.svg": 781,
	"./icon-trash.png": 782,
	"./icon-trash.svg": 783,
	"./icon-update.png": 784,
	"./icon-update.svg": 785,
	"./icon-upload.png": 786,
	"./icon-upload.svg": 787,
	"./icon-user-group-white.png": 788,
	"./icon-user-group-white.svg": 789,
	"./icon-user-group.png": 790,
	"./icon-user-group.svg": 791,
	"./icon-user-white.png": 792,
	"./icon-user-white.svg": 793,
	"./icon-user.png": 794,
	"./icon-user.svg": 795,
	"./icon-view.svg": 796,
	"./icon-warning-sign.png": 797,
	"./icon-warning-sign.svg": 798,
	"./icon-warning.png": 799,
	"./icon-warning.svg": 800,
	"./icon-wrong.svg": 801,
	"./info-circle-solid.svg": 802,
	"./sample-icon.png": 803,
	"./sample-icon.svg": 804,
	"./warn.svg": 805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 592;